export default __webpack_public_path__ + "static/media/nossasunidades2.4fe42b89.webp";